import { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const CameraIcon = ({
  width = '54',
  height = '54'
}: Omit<IconSvgProps, 'children'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2351_43038)">
        <path
          d="M46.0945 10.7193H42.8786L41.9331 8.29124C41.2685 6.58251 39.6326 5.35938 38.2015 5.35938H26.116C24.686 5.35938 23.0501 6.58251 22.3844 8.29124L21.4389 10.7193H13.9351V8.57532H6.4312V10.8158C3.38999 11.3271 1.07129 13.9652 1.07129 17.1512V39.6628C1.07129 43.2153 3.95063 46.0947 7.50318 46.0947H46.0945C49.6471 46.0947 52.5264 43.2153 52.5264 39.6628V17.1512C52.5264 13.5986 49.6471 10.7193 46.0945 10.7193Z"
          stroke="#CCCCCC"
          strokeWidth="2.20791"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.50334 15.0078C6.93472 15.0078 6.3894 15.2337 5.98733 15.6358C5.58526 16.0378 5.35938 16.5832 5.35938 17.1518C5.35938 17.7204 5.58526 18.2657 5.98733 18.6678C6.3894 19.0699 6.93472 19.2957 7.50334 19.2957C8.07195 19.2957 8.61728 19.0699 9.01935 18.6678C9.42142 18.2657 9.6473 17.7204 9.6473 17.1518C9.6473 16.5832 9.42142 16.0378 9.01935 15.6358C8.61728 15.2337 8.07195 15.0078 7.50334 15.0078Z"
          fill="#CCCCCC"
        />
        <path
          d="M32.1597 40.7354C39.2616 40.7354 45.0235 34.9735 45.0235 27.8716C45.0235 20.7697 39.2616 15.0078 32.1597 15.0078C25.0578 15.0078 19.2959 20.7697 19.2959 27.8716C19.2959 34.9735 25.0578 40.7354 32.1597 40.7354Z"
          stroke="#CCCCCC"
          strokeWidth="2.20791"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2351_43038">
          <rect width="53.5991" height="53.5991" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CameraIcon
